export default __webpack_public_path__ + "static/inside-bg-3-b2be80f1f954d3711f72993be9649b33.jpg";